import { render, staticRenderFns } from "./forwarder.vue?vue&type=template&id=c2dd01c8&scoped=true&"
import script from "./forwarder.vue?vue&type=script&lang=js&"
export * from "./forwarder.vue?vue&type=script&lang=js&"
import style0 from "./forwarder.vue?vue&type=style&index=0&id=c2dd01c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd01c8",
  null
  
)

export default component.exports